/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayerContract } from './PayerContract';
import {
    PayerContractFromJSON,
    PayerContractFromJSONTyped,
    PayerContractToJSON,
    PayerContractToJSONTyped,
} from './PayerContract';

/**
 * 
 * @export
 * @interface GetPayerContracts200Response
 */
export interface GetPayerContracts200Response {
    /**
     * 
     */
    data?: Array<PayerContract>;
}

/**
 * Check if a given object implements the GetPayerContracts200Response interface.
 */
export function instanceOfGetPayerContracts200Response(value: object): value is GetPayerContracts200Response {
    return true;
}

export function GetPayerContracts200ResponseFromJSON(json: any): GetPayerContracts200Response {
    return GetPayerContracts200ResponseFromJSONTyped(json, false);
}

export function GetPayerContracts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContracts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PayerContractFromJSON)),
    };
}

export function GetPayerContracts200ResponseToJSON(json: any): GetPayerContracts200Response {
    return GetPayerContracts200ResponseToJSONTyped(json, false);
}

export function GetPayerContracts200ResponseToJSONTyped(value?: GetPayerContracts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PayerContractToJSON)),
    };
}

